<app-dialog-close-cross></app-dialog-close-cross>
<div mat-dialog-title>{{'HELPER.INGREDIENTS.POPIN_TITLE' | translate}}</div>
<div mat-dialog-content>
  <div class="line">
    <span class="number">1</span> {{'HELPER.INGREDIENTS.POPIN_STEP1' | translate}}
  </div>
  <div class="line">
    <span class="number">2</span> {{'HELPER.INGREDIENTS.POPIN_STEP2' | translate}}
  </div>
  <div class="line">
    <span class="number">3</span> ✨ {{'HELPER.INGREDIENTS.POPIN_STEP3' | translate}} ✨
  </div>
</div>
<div mat-dialog-actions>
  <button  class="space-h-s btn-submit" mat-raised-button (click)="cancel()">{{'HELPER.INGREDIENTS.POPIN_BTN' | translate}}</button>
</div>
